import React from "react";
import { IconButton as MuiIconButton } from "@mui/material";

const IconButton = React.forwardRef<HTMLButtonElement, any>(({ icon, color, ...rest }, ref) => {
  return (
    <MuiIconButton
      ref={ref}
      sx={{
        color: color,
        "&:hover": {
          // backgroundColor: "transparent !important",
        },
      }}
      {...rest}
    >
      {icon}
    </MuiIconButton>
  );
});

IconButton.displayName = "IconButton";

export default IconButton;
